// グローバルに使いたいモジュール,関数はこちらで定義
// 残りはcomponents配下に配置してバンドルする方向性

$(function() {
	/*
	 * News Footer揃え
	 */
	if ($(".News").length) {
		$(".News").css({
			"min-height": $(window).height() - $(".Footer").height() - 50 - (56 * 2) - (48 * 2)
		});
	}
	$(document).on("click", ".Scroll", function() {
		$('body, html').animate({ scrollTop: $(window).height() }, 500); //0.5秒かけてトップへ戻る
	});
	//
	var $pagetop = $('.PageTop');
	var $pagetop_offset = 50;
	$pagetop.on('click', function(e) {
		e.preventDefault();
		var _dest = $($(this).find('a').attr('href')).offset().top;
		$('html, body').animate({
			scrollTop: _dest
		}, 1200, 'easeInOutQuart');
	});

	$(window).on('scroll', function() {
		if ($(this).scrollTop() > $pagetop_offset) {
			$pagetop.css('visibility', 'visible').addClass('visible');
		} else {
			$pagetop.removeClass('visible');
		}
	});
	//
	$w = $(window).width();
	if ($w <= 768) {
		$(".Nav").css({
			height: $(window).height() - $("#Header").height(),
			top: $("#Header").height()
		});


		$('#NavOpen').click(function() {
			var text = $(this).find('p').text();
			$(this).toggleClass('Active');
			$(this).find('p').text(text == 'メニュー' ? '閉じる' : 'メニュー');
			$('#Nav').slideToggle('fast');
		});
		$('#Nav li a').click(function() {
			var text = $('#NavOpen').find('p').text();
			$('#NavOpen').toggleClass('Active');
			$('#NavOpen').find('p').text(text == 'メニュー' ? '閉じる' : 'メニュー');
			$('#Nav').slideToggle('fast');
		});
	}
})



$(window).resize(function() {
	$w = $(window).width();
	if ($w <= 768) {
		$(".Nav").css({
			height: $(window).height() - $("#Header").height(),
			top: $("#Header").height()
		}).hide();
	} else {
		$(".Nav").css({
			height: "auto",
			top: "auto"
		}).show();
	}
})